import { Container, spine, Ticker } from 'pixi.js';

spine.Spine.prototype.autoUpdateTransform = function (): void {
  if (spine.Spine.globalAutoUpdate) {
    this.update(Ticker.shared.deltaMS * 0.001);
  }
  Container.prototype.updateTransform.call(this);
};
